/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_Locale_MissingInputs */

const en_error_email_locale_missing = /** @type {(inputs: Error_Email_Locale_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The email has no version in that language.`)
};

/**
* | output |
* | --- |
* | "The email has no version in that language." |
*
* @param {Error_Email_Locale_MissingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_email_locale_missing = /** @type {((inputs?: Error_Email_Locale_MissingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_Locale_MissingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_email_locale_missing(inputs)
});